import Clevertap from '@/analytics/clevertap'
import {
  AMENDMENT_AIR_UI_ACTION_NAMES,
  AMENDMENT_CASE_POPUP_EVENT_NAMES,
  AMENDMENT_CLEVERTAP_EVENT,
  AMENDMENT_DATE_WARNING_POPUP_FIELDS,
  AMENDMENT_FETCH_TRAVELLER_EVENT_NAMES,
  SELECT_DATE_PAGE_API_FAILURE_FIELDS,
  SELECT_DATE_PAGE_NAME,
} from '@/constants/analytics/amendmentSelectDatesClevertap'
import { AMEND_SUPPORT_REASON } from '@/constants/amendmentSupportCase'
import type { TravellerDetailsResponse } from '@/types/amendTraveller'
import { buildAmendmentClevertapBasePayload } from '@/utils/amend/buildAmendmentClevertapBasePayload'

function clevertapTripId(tripId: string): string {
  return `id_${tripId}`
}
const ROUND_TRIP = 'Round Trip'
const ONEWAY = 'Oneway'
export function trackAmendSelectDatePageShown(tripId: string, details: TravellerDetailsResponse): void {
  Clevertap.event(AMENDMENT_CLEVERTAP_EVENT.AMENDMENT, {
    event_name: AMENDMENT_FETCH_TRAVELLER_EVENT_NAMES.SELECT_DATE_PAGE_SHOWN,
    page_name: SELECT_DATE_PAGE_NAME,
    trip_id: clevertapTripId(tripId),
    journey_type: details.isRt ? ROUND_TRIP : ONEWAY,
    isIntl: details.isIntl,
    flexifly: details.isFlexiFlyTrip,
  })
}

export function trackAmendSelectDateEligibilityFailed(
  tripId: string,
  errorText: string,
  reason: string
): void {
  Clevertap.event(AMENDMENT_CLEVERTAP_EVENT.AMENDMENT, {
    event_name: AMENDMENT_FETCH_TRAVELLER_EVENT_NAMES.SELECT_DATE_PAGE_ELIGIBILITY_FAILED,
    trip_id: clevertapTripId(tripId),
    errorText,
    reason,
  })
}

export function trackAmendSelectDateApiFailed(): void {
  Clevertap.event(AMENDMENT_CLEVERTAP_EVENT.AMENDMENT, { ...SELECT_DATE_PAGE_API_FAILURE_FIELDS })
}

export function trackAmendCasePopupLoad(params: {
  tripId: string
  isSms: boolean
  userEmail: string
  caseReason: string
}): void {
  const {tripId, isSms, userEmail, caseReason} = params ?? {}
  const base = buildAmendmentClevertapBasePayload(tripId, isSms, userEmail )
  Clevertap.event(AMENDMENT_CLEVERTAP_EVENT.AMENDMENT, {
    ...base,
    event_name: AMENDMENT_CASE_POPUP_EVENT_NAMES.POPUP_LOAD,
  })
  if (caseReason === AMEND_SUPPORT_REASON.SPECIAL_RT_ERROR_AMEND) {
    Clevertap.event(AMENDMENT_CLEVERTAP_EVENT.AMENDMENT, {
      ...base,
      event_name: AMENDMENT_CASE_POPUP_EVENT_NAMES.CASE_CREATION_SPECIAL_RT,
    })
  }
}

export function trackAmendCaseBackClicked(params: {
  tripId: string
  isSms: boolean
  userEmail: string
}): void {
  const {tripId, isSms, userEmail} = params ?? {}
  const base = buildAmendmentClevertapBasePayload(tripId, isSms, userEmail)
  Clevertap.event(AMENDMENT_CLEVERTAP_EVENT.AMENDMENT, {
    ...base,
    event_name: AMENDMENT_CASE_POPUP_EVENT_NAMES.CASE_CREATION_BACK_CLICKED,
  })
} 

export function trackAmendDateWarningPopupLoad(params: {
  tripId: string
  isSms: boolean
  userEmail: string
}): void {
  const {tripId, isSms, userEmail} = params ?? {}
  const base = buildAmendmentClevertapBasePayload( tripId, isSms, userEmail)
  Clevertap.event(AMENDMENT_CLEVERTAP_EVENT.AMENDMENT, {
    ...base,
    ...AMENDMENT_DATE_WARNING_POPUP_FIELDS,
    event_name: AMENDMENT_CASE_POPUP_EVENT_NAMES.POPUP_LOAD,
  })
}

export function trackAmendDateWarningAction(params: {
  tripId: string
  isSms: boolean
  userEmail: string
  isRt: boolean
  isIntl: boolean
  isFlexiFlyTrip: boolean
  actionName: string
  message: string
}): void {
  const {tripId, isSms, userEmail, isRt, isIntl, isFlexiFlyTrip, actionName, message} = params ?? {}
  const base = buildAmendmentClevertapBasePayload(tripId, isSms, userEmail)
  Clevertap.event(AMENDMENT_CLEVERTAP_EVENT.AIR_UI_ACTION, {
    ...base,
    action_name: actionName,
    message: message,
    journey_type: isRt ? ROUND_TRIP : ONEWAY,
    isIntl: isIntl,
    flexifly: isFlexiFlyTrip,
  })
}

export function trackAmendSearchAlternateClicked(params: {
  tripId: string
  isSms: boolean
  userEmail: string
  isRt: boolean
  isIntl: boolean
  isFlexiFlyTrip: boolean
  validationErrorMessages?: string[]
}): void {
  const {tripId, isSms, userEmail, isRt, isIntl, isFlexiFlyTrip, validationErrorMessages} = params ?? {}
  const base = buildAmendmentClevertapBasePayload( tripId, isSms, userEmail)
  const err = (validationErrorMessages ?? []).filter(Boolean)
  Clevertap.event(AMENDMENT_CLEVERTAP_EVENT.AIR_UI_ACTION, {
    ...base,
    action_name: AMENDMENT_AIR_UI_ACTION_NAMES.SEARCH_ALTERNATE_CLICKED,
    ...(err.length > 0 ? { error_msg: err.join(', ') } : {}),
    journey_type: isRt ? ROUND_TRIP : ONEWAY,
    isIntl: isIntl,
    flexifly: isFlexiFlyTrip,
  })
}
